(() => {
  const roots = document.querySelectorAll('[data-lv-initials-root]');
  if (!roots.length) return;

  const sanitize = (v) =>
    (v || '')
      .toUpperCase()
      .replace(/[^A-Z]/g, '')
      .slice(0, 2);

  roots.forEach((root) => {
    const openBtn = root.querySelector('[data-lv-open]');
    const modal = root.querySelector('[data-lv-modal]');
    const closes = root.querySelectorAll('[data-lv-close]');
    const input = root.querySelector('[data-lv-input]');
    const count = root.querySelector('[data-lv-count]');
    const validate = root.querySelector('[data-lv-validate]');
    const hidden = root.querySelector('[data-lv-hidden]');
    const preview = root.querySelector('[data-lv-preview]');

    if (!openBtn || !modal || !input || !validate || !hidden) return;

    const render = () => {
      const v = sanitize(input.value);
      input.value = v;
      if (count) count.textContent = String(v.length);
      validate.disabled = v.length !== 2;
    };

    const open = () => {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      // carga valor previo si existe, si no vacío
      input.value = sanitize(hidden.value || '');
      render();
      setTimeout(() => input.focus(), 50);
    };

    const close = () => {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    };

    openBtn.addEventListener('click', () => open());

    closes.forEach((btn) => btn.addEventListener('click', () => close()));

    document.addEventListener('keydown', (e) => {
      if (!modal.hidden && e.key === 'Escape') close();
    });

    input.addEventListener('input', render);

    validate.addEventListener('click', () => {
      const v = sanitize(input.value);
      hidden.value = v;

      if (preview) preview.textContent = v || '-';
      close();
    });

    // preview inicial si ya hay valor
    if (preview) preview.textContent = sanitize(hidden.value) || '-';
  });
})();
